import { Injectable, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { MsgModel } from '../model/msg.model';

@Injectable({
  providedIn: 'root'
})
export class MsgService {
  msg: MsgModel = new MsgModel;
  messages$: Subject<any>;

  add(message: MsgModel) {
    this.msg = message;
    this.messages$.next(this.msg);
  }

  clear() {
    this.msg = new MsgModel;
  }

  constructor() { 
    this.messages$ = new Subject<any>();
  }
}
